import RequestAbstract from "../abstract";

export default class FiltersCardsWhitelists extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/filters-cards-whitelists";
    }

}
